import EquipmentIcon from '@screens/EquipmentDetail/components/EquipmentIcon'
import Avatar from '@components/@vuexy/avatar/AvatarComponent'
import Spinner from '@components/@vuexy/spinner/Loading-spinner'
import DataList from '@components/DataList'
import {SUB_PATH} from '@common/config'
import {isUndefined, numberWithCommas} from '@common/utils'
import React, {useEffect, useState} from 'react'
import {Badge, Button, Card, CardBody, Col, FormGroup, Modal, ModalBody, ModalHeader, Row} from 'reactstrap'
import * as AssetApi from '@apis/asset'
import {ResponseStatus} from '@common/constants'
import SweetAlert from "react-bootstrap-sweetalert";
import AddIcon from "@assets/img/icons/add_icon.png";
import imgDefault from '@assets/img/img_default.png'
import {getOfMeterUnlinkByCriteria} from '@apis/asset'

export default ({shop, cduId, meterId, equipments, iotData, showUnlinkModal, equipment}) => {
    const [isLoading, setLoading] = useState(false)
    const closeAlert = () => {
        setAlertModel({isShow: false, callback: closeAlert})
    }
    const [alertModel, setAlertModel] = useState({isShow: false, callback: closeAlert})
    const showAlert = (type, header, message, callback, showCancel = false) => {
        setAlertModel({
            isShow: true,
            header: header,
            message: message,
            type: type,
            callback: callback,
            showCancel: showCancel,
        })
    }
    const [openAssetModel, setOpenAssetModel] = useState(false)
    const [criteriaData, setCriteriaData] = useState({
        pageNumber: 1,
        pageSize: 10,
        returnTotalRecord: true,
        shopId: shop.id
    })
    const [assets, setAssets] = useState([])

    useEffect(() => {
        setAssets(equipments)
    }, [equipments])

    const goToDevice = (assetId) => {
        window.location = SUB_PATH + `/shop-asset/${shop.id}/${assetId}`
    }

    const unlinkModal = async (assetId) => {
        closeAlert()
        setLoading(true)

        const formData = new FormData()
        if(cduId) {
          formData.append('cduAssetId', '-')
        } else if (meterId) {
          formData.append('meterAssetId', '-')
        }
        formData.append('id', assetId)
        const response = await AssetApi.update(formData)
        if (response.status === ResponseStatus.SUCCESS) {
            const idx = assets.findIndex(e => e.id === assetId);
            assets.splice(idx, 1)
        } else {
            showAlert('error', 'Error', 'Something went wrong.', closeAlert)
        }

        setLoading(false)
    }

    const onUnlinkModal = async (name, assetId) => {
        showAlert('warning', 'Warning', `Confirm unlink ${name} ?`, () => unlinkModal(assetId), true)
    }

    const linkModal = async (asset) => {
        setOpenAssetModel(false)
        closeAlert()
        setLoading(true)

        const formData = new FormData()
        if(cduId) {
          formData.append('cduAssetId', cduId)
        } else if (meterId) {
          formData.append('meterAssetId', meterId)
        }
        formData.append('id', asset.assetId)
        const response = await AssetApi.update(formData)
        if (response.status === ResponseStatus.SUCCESS) {
            const newAsset = {
                id: asset.assetId,
                serial: asset.serial,
                AssetModel: {
                    assetType: asset.assetType,
                    imageFilePath: asset.imageFilePath
                }
            }
            setAssets(assets.concat([newAsset]))
        } else {
            showAlert('error', 'Error', 'Something went wrong.', closeAlert)
        }

        setLoading(false)
    }

    const onLinkModal = async (item) => {
        showAlert('warning', 'Warning', `Confirm link ${item.serial} ?`, () => linkModal(item), true)
    }

    const columns = [
        {
            name: 'Actions',
            sortable: false,
            center: true,
            cell: row => <Button.Ripple color='success' size='sm'
                                        onClick={() => onLinkModal(row)}>Link</Button.Ripple>
        },
        {
            name: 'Image',
            selector: 'image',
            width: '100px',
            cell: row => (
                <img
                    height='80%'
                    width='80%'
                    src={row.imageFilePath || imgDefault}
                    alt={row.name}
                />
            )
        },
        {
            name: 'Asset No',
            selector: 'asset-no',
            sortable: true,
            minWidth: '50px',
            cell: row => (
                <p title={row.assetNo} className='text-truncate text-bold-500 mb-0'>
                    <span className='primary'>{row.assetNo}</span><br/>
                    <span className='text-info-header'>{row.serial}</span>
                </p>
            )
        },
        {
            name: 'Asset Type',
            selector: 'asset-type',
            sortable: true,
            minWidth: '50px',
            cell: row => (
                <p title={row.assetType} className='text-truncate text-bold-500 mb-0'>
                    <span>{row.assetGroup}</span><br/>
                    <span className='text-info-header'>{row.assetType}</span>
                </p>
            )
        },
    ]

    const renderAssetListModal = () => {
        return <Modal isOpen={openAssetModel} toggle={() => setOpenAssetModel(false)} className="modal-lg">
            <ModalHeader toggle={() => setOpenAssetModel(false)}>
                <h3>Equipment Lists</h3>
            </ModalHeader>
            <ModalBody>
                <DataList columns={columns} queryApi={cduId ? AssetApi.getRefrigUnlinkByCriteria : AssetApi.getOfMeterUnlinkByCriteria}
                          hideAddButton={true} defaultCriteria={criteriaData}/>
            </ModalBody>
        </Modal>
    }

    return (
        <>
            <Col lg='3' md='3' sm='12'>
                <Card className='temp-container'>
                    <CardBody>
                      {equipment.assetType === 'Meter' ?
                        <>
                          <span>Power (W)</span>
                          <div className="temp-score">{numberWithCommas(iotData?.power) || '-'}</div>
                        </> :
                        <>
                          <span>Cabinet Temp (&deg;C)</span>
                          <div className="temp-score">{iotData?.tempRoom || '-'}</div>
                        </>}
                      <hr/>
                      {isLoading ? <Row className='mt-3'><Spinner/></Row> :
                            <Row>
                                {assets && assets.length > 0 && assets.map((item) => {
                                    return <Col key={item.id} md="6" sm="6">
                                        <LinkedDevice equipment={item} goToDevice={goToDevice}
                                                      onUnlinkModal={onUnlinkModal}
                                                      showUnlinkModal={showUnlinkModal}/>
                                    </Col>
                                })}
                                {showUnlinkModal && (!assets || (cduId && assets.length < 3) || (meterId && assets.length < 10)) &&
                                <Col key='-1' md="6" sm="6">
                                    <div className='text-center' onClick={() => setOpenAssetModel(true)}>
                                        <Avatar size='lg' img={AddIcon}/>
                                    </div>
                                </Col>}
                            </Row>
                        }
                    </CardBody>
                </Card>
            </Col>

            <SweetAlert
                type={alertModel.type}
                title={alertModel.header || ''}
                show={alertModel.isShow}
                onConfirm={alertModel.callback}
                onCancel={closeAlert}
                showCancel={alertModel.showCancel}
                showConfirm={alertModel.type === 'success' ? false : true}
                reverseButtons
                cancelBtnBsStyle='danger'
                timeout={alertModel.type === 'success' ? 1000 : null}
            >
                <p className='sweet-alert-text'>{alertModel.message}</p>
            </SweetAlert>

            {renderAssetListModal()}
        </>
    )
}

const LinkedDevice = ({equipment, showUnlinkModal, goToDevice, onUnlinkModal}) => {
    return (
        <div className='text-center' onClick={() => goToDevice(equipment.id)}>
            <EquipmentIcon assetTypeName={!isUndefined(equipment.AssetModel) ? equipment.AssetModel.assetType : ''}
                           roundIcon={true} imageFilePath={equipment.AssetModel.imageFilePath}/>
            <div className='linkeddevice-serial'>{equipment.serial}</div>
            {showUnlinkModal &&
            <Button.Ripple color='secondary' size='sm'
                           onClick={() => onUnlinkModal(equipment.serial, equipment.id)}>Unlink</Button.Ripple>}
        </div>
    )
}
